import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Topbar from "../../Component/Topbar/Topbar";
import { Table } from "../../Component/Table/Table";
import moment from "moment";

const CustomerPrinters = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const formType = location.state?.type; // "add" | "edit" | "view"
  const isViewMode = formType === "view";
  const isEditMode = formType === "edit";
  const [list, setList] = useState([]);
  const [page, setPage] = useState(1);
  const [pagination, setPagination] = useState("");
  const data = location?.state?.data;
  console.log("data", data);

  const columns = React.useMemo(
    () => [
      {
        Header: "S No",
        accessor: "",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{row?.index + 1}</p>;
        },
      },
      {
        Header: "Invoice No",
        accessor: "invoice_no",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Printer Sr. No.",
        accessor: "sr_no",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Date",
        accessor: "purchase_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
      {
        Header: "Installation Date",
        accessor: "installation_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
      {
        Header: "Warranty Start",
        accessor: "wr_start_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
      {
        Header: "Warranty Expiry",
        accessor: "wr_end_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
      {
        Header: "AMC / CAMC",
        accessor: "type",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap ">{value}</p>;
        },
      },
      {
        Header: "Start Date",
        accessor: "amc_start_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
      {
        Header: "End Date",
        accessor: "amc_end_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap ">
              {value ? moment(value).format("DD-MM-YYYY") : ""}
            </p>
          );
        },
      },
    ],
    [],
  );
  return (
    <>
      <Topbar
        header={"Customer"}
        subHead={isViewMode ? "View" : isEditMode ? "Edit" : "Add"}
      />
      <div className="container_fluit1">
        <div className="d-flex gap-4 flex-wrap">
          <div className="col-md-5">
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Customer ID
            </label>
            <input value={data?.code} className="input-box" readOnly />
          </div>
          <div className="col-md-5">
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Customer Name
            </label>
            <input value={data?.name} className="input-box" readOnly />
          </div>
          <div className="col-md-5">
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Email ID
            </label>
            <input
              value={data?.email}
              className="input-box"
              readOnly
              type="email"
            />
          </div>
          <div className="col-md-5">
            <label className="f3 fs-sm-12 fs-md-14 fs-lg-16 fs-xl-17 fs-xxl-20 mb-1">
              Mobile Number
            </label>
            <input value={data?.mobile} className="input-box" readOnly />
          </div>
        </div>
        <h4 className="f3 fs-sm-15 fs-md-19 fs-lg-20 fs-xl-22 fs-xxl-24 my-4">
          Total Printers : {data?.printers?.length}
        </h4>

        <Table
          columns={columns}
          pageno={page}
          setPageno={setPage}
          // pagecount={pagination}
          data={data?.printers ?? []}
          show={true}
        />
      </div>
    </>
  );
};

export default CustomerPrinters;
